export default "__VITE_ASSET__aBERVe8H__"